import React, { useContext } from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import ReviewCards from "./ReviewCards";
import { ReviewContext } from "./ReviewContext";



const Reviews = () => {
    // const reviews = [ { "issue_id": "IS25071507", "issue_status": "Resolved", "rating": 1, "reply": null, "review_id": "RV250715K27", "review_text": "evidence.\nPush court test main he.", "timestamp": "Sat, 07 Jun 2025 14:55:17 GMT", "user": { "county": null, "email": "byronkorir2@gmail.com", "name": "Byron User", "organisation": null, "phone": null, "profile": "https://picsum.photos/366/1019", "role": "user", "status": "active", "user_id": "US2506262" } }, { "issue_id": "IS25071508", "issue_status": "Resolved", "rating": 2, "reply": null, "review_id": "RV250715K28", "review_text": "Somebody now condition tree enjoy condition idea. Already building but billion vote. Themselves you yes response condition until yes own. Quite back good.\nBy might night whatever speech nation.\nInstead drug such kid represent will later.", "timestamp": "Sun, 22 Jun 2025 14:55:17 GMT", "user": { "county": null, "email": "byronkorir2@gmail.com", "name": "Byron User", "organisation": null, "phone": null, "profile": "https://picsum.photos/366/1019", "role": "user", "status": "active", "user_id": "US2506262" } }, { "issue_id": "IS25071509", "issue_status": "Resolved", "rating": 4, "reply": { "admin": { "county": "Nakuru", "email": "korirbyron1@gmail.com", "name": "Byron Admin", "organisation": "Jones Plc", "phone": "(613)910-6451", "profile": "https://placekitten.com/318/22", "role": "admin", "status": "active", "user_id": "US2506261" }, "replied_at": "Mon, 26 May 2025 14:55:17 GMT", "reply_id": "RP2507151335", "reply_text": "Protect table phone sort.\nBeat husband quickly rather send scientist. Factor let partner character.\nThus father piece people quickly work." }, "review_id": "RV250715K29", "review_text": "Sound general brother build state discussion history write. Change line smile accept.\nCondition on report top organization.\nKitchen drive again eat available car service.", "timestamp": "Sun, 25 May 2025 14:55:17 GMT", "user": { "county": null, "email": "korirbyron6@gmail.com", "name": "Mark Hill", "organisation": null, "phone": null, "profile": "https://dummyimage.com/517x767", "role": "user", "status": "active", "user_id": "US2506263" } } ]
  const {reviews} = useContext(ReviewContext)


  return (
    <Box py={6} px={2} sx={{ backgroundColor: "rgba(70, 138, 100, 0.86)" }}>
      <Typography
        variant="h4"
        align="center"
        fontWeight={700}
        gutterBottom
        color="#ffffff"
      >
         Reviews
      </Typography>
      <Typography
        variant="subtitle1"
        align="center"
        color="#ffffff"
        mb={4}
      >
        Hear what others are saying about MazGuard! Your feedback helps us grow and improve.
      </Typography>

      {/* Carousel Container */}
      <ReviewCards reviews={reviews} />

      {/* Popup */}
      {/* <ReviewPopup
        open={!!selectedReview}
        handleClose={() => setSelectedReview(null)}
        review={selectedReview}
      /> */}
    </Box>
  );
};

export default Reviews;
